import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Achivement.css";
import achTopIcon from "../../image/newImg/ach.png";
import bullet_icon from "../../image/bullet_icon.svg";
import award_1 from "../../image/award_1.jpg";
import award_2 from "../../image/award_2.jpg";
import award_3 from "../../image/award_3.jpg";
import award_4 from "../../image/award_4.jpg";
import award_5 from "../../image/award_5.jpg";
import award_6 from "../../image/award_6.jpg";
import award_7 from "../../image/award_7.jpg";
import award_8 from "../../image/award_8.jpg";
import award_9 from "../../image/award_9.jpg";
import award_10 from "../../image/award_10.jpg";
import award_11 from "../../image/award_11.jpeg";
import a1 from "../../image/newImg/a1.jpg";
import a2 from "../../image/newImg/a2.jpg";
import a3 from "../../image/newImg/a3.jpg";
import a4 from "../../image/newImg/a4.jpg";
import a5 from "../../image/newImg/a5.jpg";
import a6 from "../../image/newImg/a6.jpg";
import a7 from "../../image/newImg/a7.jpg";
import a8 from "../../image/newImg/a8.jpg";
import a9 from "../../image/newImg/a9.jpg";
import a10 from "../../image/newImg/a10.png";
import a11 from "../../image/newImg/a11.png";
import a12 from "../../image/newImg/a12.jpg";
import { Col, Row } from "react-bootstrap";
import NewNavbar from "../NavBar/NewNavbar";
import Slider from "react-slick";


const ReadMoreText = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Split content into words
  const words = text.trim().split(/\s+/);
  const wordLimit = 17;

  // Check if content exceeds limit
  const isLong = words.length > wordLimit;

  // Get preview content
  const previewText = words.slice(0, wordLimit).join(" ");

  return (
    <div>
      <p>
        {isExpanded || !isLong
          ? text
          : previewText + "..."}
      </p>

      {isLong && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            cursor: "pointer",
            padding: 0
          }}
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};


function Achievements(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {    
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);    
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const images = [
    award_1,
    award_2,
    award_3,
    award_4,
    award_5,
    award_6,
    award_7,
    award_8,
    award_9,
    award_10,
    award_11,
  ];
  const data = [
    {
      title: "Mayank Sharma",
      subtitle: "(Grade VIII) - 2nd position",
      description: `District Level Clay Modelling Competition organized by Bal Bhawan in Jan 2021`,
      image: a1,
    },
    {
      title: "Aniket",
      subtitle: "(Grade IX) - 3rd position",
      description: `District Road Safety Festival, February 2021`,
      image: a2,
    },
    {
      title: "Vashnavi Shukla",
      subtitle: "(Grade 1) - 1st position",
      description: `Inter-School ‘Baby Show Competition’ in Feb 2021`,
      image: a3,
    },
    {
      title: "Nihal",
      subtitle: "(Grade VII) - 2nd position",
      description: `District Level JAM Competition in August 2020`,
      image: a4,
    },
    {
      title: "Yash",
      subtitle: "(Grade XI) - 1st position",
      description: `State Level Cricket Tournament held in Rohtak, Haryana`,
      image: a5,
    },
    {
      title: "Sustainable city",
      subtitle: "Model of a sustainable city on “Panchtatva” by students of primary",
      description: `District Road Safety Festival, February 2021`,
      image: a10,
    },
    {
      title: "Nisar Ali",
      subtitle: "(Grade XII) - Gold medal, (Grade XII) - Silver medal,(Grade XII) - Bronze medal",
      description: `Open Football Tournament organized by Shiv Football Club`,
      image: a7,
    },
    {
      title: "Diksha, Vasudev, Lovely",
      subtitle: "(Grade XII ) - Runner up",
      description: `Political Science Olympiad`,
      image: a8,
    },
    {
      title: "Ridheeshree Nayak, Chirag Sharma, Krishna Mohan",
      subtitle: "Grade IX,Grade VIII (2nd position in Science Quiz), 2nd position in Web Designing.",
      description: `Inter-School Science Fiesta`,
      image: a9,
    },
    {
      title: "Tapish Nagar",
      subtitle: "(Grade XI) - 1st position.",
      description: `A RUN FOR ENVIRONMENT-A RACE organised by Panjabi Samaj Sabha Faridabad & Rotary Club Midtown RY 2021-22`,
      image: a6,
    },
  ]

  return (
    <div className="content_main" onScroll={handleScroll}>
      <NewNavbar handleClick={handleClick} />      
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`}>            
            Achievements & Laurels
          </div>
          <div>
            <div className="d-flex gap-2 mt-1">
              <div className="container">
                <div className="color-grey f-500">
                  Herman Gmeiner School proudly highlights its achievements and
                  presents the best of its students, whether they are excelling
                  academically, athletically or in service to the community. We
                  hope to inspire more students to excel, their achievements
                  ultimately make the school become stronger.By highlighting
                  student achievements, we aim to eliminate self-doubt and build
                  confidence in our students that hard work is important and is
                  making an impact. In turn, this confidence can carry over to
                  other facets of their young lives, including making smart
                  choices when faced with several challenges as they grow up.
                </div>


                <div className="achievement_section mt-5">
                  <div className="achievement_content row">
                    <div className="col-lg-6 achiecontent">
                      <h2 className="section_titless">School’s Achievements</h2>
                      <ul>
                        <li> Global School Award for Innovation in Pedagogical Practices in 2020 </li>
                        <li> Best Teaching Excellence Award by International School Award held at Dubai in 2018 </li>
                        <li> Indian School Award in 2018 </li>
                        <li> National School Award 2018 </li>
                        <li>  Global Sustainable School Award 2017 as a recognition of its efforts towards community service and environment</li>
                      </ul>
                    </div>
                    <div className="col-lg-6 achieveimage">
                      <img className="acsimg1 " src={a11} alt="International cultural exchange program (India and Vietnam)" />
                      <img className="acsimg1 " src={a12} alt="International cultural exchange program (India and Malysia)" />
                    </div>
                  </div>
                </div>


                <div style={{ marginTop: "2rem", marginBottom: "1.5rem" }}>
                  <p style={{ fontSize: "1.5rem" }}>
                    <b>Students' Achievements</b>
                  </p>
                </div>

                <div className="row mt-4">
                  {data.map((item, i) => {
                    return (
                      (i % 2 == 0) ? (
                        <div className="col-lg-6" >
                          <div className="news-card">
                            <div className="news-text">
                              <div className="news-date">
                                <span className="news-day"> {item.title}</span>
                              </div>
                              <p className="mb-1"><b>{item.subtitle}</b></p>
                              <ReadMoreText text={item.description} />
                            </div>
                            <div className="news-img">
                              <img src={item.image} alt={item.title} />
                            </div>
                          </div>
                        </div>)
                        : (
                          <div className="col-lg-6">
                            <div className="news-card flex-row-reverse">
                              <div className="news-text text-end">
                                <div className="news-date">
                                  <span className="news-day"> {item.title}</span>
                                </div>
                                <p className="mb-1"><b>{item.subtitle}</b></p>
                                <ReadMoreText text={item.description} />
                              </div>
                              <div className="news-img">
                                <img src={item.image} alt={item.title} />
                              </div>
                            </div>
                          </div>
                        )
                    )

                  })}
                </div>

                <div className="container py-4 silderac">
                  <h2 className="fw-bold text-center mb-4">Awards Gallery</h2>

                  <Slider {...settings}>
                    {images.map((img, i) => (
                      <div key={i} className="img-slide-wrapper">
                        <img src={img} alt="gallery" className="slider-img" />
                      </div>
                    ))}
                  </Slider>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Achievements;
